import './styles.scss';

interface TitleProps {
  children: any;
  className?: string;
}

export const Title: React.FC<TitleProps> = ({ children, className }) => <div className={`title ${className}`}>{children}</div>;
